import React from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
export default (function (_ref) {
  var type = _ref.type,
    label = _ref.label,
    onClick = _ref.onClick,
    config = _ref.config;
  var hideLabelsFor = {
    "addRuleGroup": true
  };
  var typeToIcon = {
    delGroup: faTrashAlt,
    delRuleGroup: faTrashAlt,
    delRule: faTrashAlt,
    addRuleGroup: faPlus,
    addRuleGroupExt: faPlus,
    addRule: faPlus,
    addGroup: faPlus
  };
  var typeToColor = {
    addRule: "primary",
    addGroup: "primary",
    delGroup: "danger",
    delRuleGroup: "danger",
    delRule: "danger"
  };
  var isOnlyIcon = hideLabelsFor[type] || !label;
  return /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    color: typeToColor[type],
    onClick: onClick
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: typeToIcon[type]
  }), " ", !isOnlyIcon && label);
});